import I18n from 'i18n-js';
import {formatPrice} from './i18n';

const RATE_PA = 0, MONTHS = 24, MIN_PRICE = 500;

type Options = {
    months?: number,
    rate?: number,
    precision?: number,
};

export default function(price: number, options?: Options) {
    if(price < MIN_PRICE)
        return;
    const rate = options?.rate ?? RATE_PA;
    const months = options?.months ?? MONTHS;
    const precision = options?.precision ?? 0;
    const monthly = rate ?
        price * (rate/12) / (1 - Math.pow(1 + rate/12, -months)) :
        price / months;
    let rateText = String(rate*100);
    if(I18n.locale === 'de')
        rateText.replace('.', ',');
    return {
        months,
        monthly,
        monthlyText: formatPrice(monthly, {precision}),
        rate,
        rateText,
    };
};
